var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.CompanyModule().companyLogo)?_c('img',{staticClass:"py-2 object-contain",staticStyle:{"height":"56px"},attrs:{"src":_vm.CompanyModule().companyLogo,"alt":"logo"}}):(_vm.filePath)?_c('div',[_c('img',{staticClass:"h-10",attrs:{"src":_vm.filePath,"alt":"logo"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }